import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { AccountCamMicEffects } from "./+state/effects";
import {
  AccountCamMicStreamFactoryService,
  AccountCamMicStreamService
} from "./+state/services";

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AccountCamMicEffects])],
  providers: [AccountCamMicStreamFactoryService, AccountCamMicStreamService]
})
export class AccountCamMicDataAccessModule {}
